import React, { useState } from 'react';
import { MdBlock } from 'react-icons/md';
import { sendAuthenticatedAsyncRequest } from 'services/AsyncRequestService';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { getErrorMessage } from 'services/UtilityService';
import Tooltip from 'react-bootstrap/Tooltip';
import { showNotification } from 'services/NotificationService';
import 'assets/css/user.css';

const DisableUser = ({ userInfoId, handler }) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const [asyncInProgress, setAsyncInProgress] = useState(false);

  const disableUser = () => {
    setAsyncInProgress(true);
    sendAuthenticatedAsyncRequest(
      `/user/disable/${userInfoId}`,
      'PUT',
      null,
      (r) => {
        setAsyncInProgress(false);
        showNotification({
          title: 'Action successful!',
          message: 'User disabled successfully.',
          position: 'tc',
          type: 'success',
        });

        handler();
      },
      (r) => {
        setAsyncInProgress(false);
        showNotification({
          title: 'Error!',
          message: getErrorMessage(r.data) || getErrorMessage('UNABLE_TO_DISABLE_USER'),
          position: 'tc',
          type: 'error',
        });
      }
    );
  };

  return (
    <OverlayTrigger overlay={<Tooltip>Disable User</Tooltip>}>
      <MdBlock
        className="user-action-button disable-user"
        size={20}
        onClick={() => {
          if (window.confirm('Are you sure you want to disable this user?')) {
            disableUser();
          }
        }}
      ></MdBlock>
    </OverlayTrigger>
  );
};

export default DisableUser;